import React from 'react';

import type {ClassData} from '../model/catalog';
import {PickList} from './pick-list';

import css from './master.module.css';

type Props = {
	classes: ClassData[];
	onSelect(classId: string): void;
	/** почему класс нельзя взять: неподходящие характеристики для мультикласса */
	blockers?(classData: ClassData): string[];
};

export const classIconUrl = (classId: string) => `/images/classes/icons/${classId}.jpeg`;

export const ClassList: React.FC<Props> = ({classes, onSelect, blockers}) => (
	<PickList
		items={classes.map((classData) => ({
			id: classData.id,
			title: classData.title,
			caption: `Кость здоровья d${classData.hitDie}`,
			blocker: blockers?.(classData).length ? `Нужно: ${blockers(classData).join('; ')}` : undefined,
			icon: <img src={classIconUrl(classData.id)} alt="" width={40} height={40} className={css.classIcon} />,
		}))}
		onSelect={onSelect}
	/>
);
